#search.vue
<template>
	<div>
		<div class="sf-search-layout__body__container">
			<sf-search-layout>
				<el-row :gutter="20">
					<el-col :span="4">
						<search-input
							:label="getMessage_('QWCC001154')"
							paramKey="deptCd"
							@commInput="setSearchParam"
							:propData="searchParams.deptCd"
						></search-input>
					</el-col>
					<el-col :span="4">
						<search-input
							:label="getMessage_('QWCC001153')"
							paramKey="deptNm"
							@commInput="setSearchParam"
							:propData="searchParams.deptNm"
						></search-input>
					</el-col>
				</el-row>
				<template slot="button">
					<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
						{{ getButtonMsg_(scrId, 'CR') }}
					</sf-button>
				</template>
			</sf-search-layout>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SearchInput from '@qms/Components/SearchInput';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {};
	},
	components: { SearchInput },
	async created() {
		try {
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message || error
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		async searchList() {
			this.$sf_toggleLoading(true);
			await this.getDeptMngList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
			// try {
			// 	this.$sf_toggleLoading(true);
			// 	await this.getDeptMngList_();
			// } catch (error) {
			// 	this.$sf_toast({
			// 		type: 'error',
			// 		message: error.message || error
			// 	});
			// } finally {
			// 	this.$sf_toggleLoading(false);
			// }
		},
		sendData(param) {
			this.setSearchParam_({ key: 'deptCd', value: param.deptCd }, { key: 'deptNm', value: param.deptNm });
			this.searchList();
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
